export default {
  path: 'routes',
  name: 'routes',
  redirect: { name: 'routes.listing' },
  component: () =>
    import(/* webpackChunkName: "itineraries" */ '@/views/Home/Itineraries'),
  children: [
    {
      path: '/',
      name: 'routes.listing',
      component: () =>
        import(
          /* webpackChunkName: "itineraries" */ '@/views/Home/Itineraries/ItineraryList'
        )
    },
    {
      path: 'create',
      name: 'routes.create',
      component: () =>
        import(
          /* webpackChunkName: "itineraries" */ '@/views/Home/Itineraries/CreateItinerary'
        )
    },
    {
      path: 'update/:id',
      name: 'routes.update',
      component: () =>
        import(
          /* webpackChunkName: "itineraries" */ '@/views/Home/Itineraries/UpdateItinerary'
        )
    }
  ]
}
